import { Upload } from 'tus-js-client';
import { makeProgressPercent } from '../utils';
export class TusUploader {
    job;
    options;
    defaultRetryDelays = [0, 5000, 5000, 10000, 10000, 15000, 15000, 20000, 20000, 30000, 30000];
    constructor(job, options) {
        this.job = job;
        this.options = options;
    }
    async start() {
        return new Promise((resolve, reject) => {
            const upload = new Upload(this.job.file, {
                storeFingerprintForResuming: false,
                endpoint: this.createEndpointUrl(),
                uploadUrl: this.createUploadUrl(),
                headers: this.createHeaders(),
                metadata: this.createMetadata(this.job),
                retryDelays: this.defaultRetryDelays,
                onBeforeRequest: (req) => {
                    if (this.options.authorizationToken) {
                        const xhr = req.getUnderlyingObject();
                        xhr.withCredentials = true;
                    }
                },
                onShouldRetry: (error) => this.onShouldRetry(error),
                onProgress: (...args) => this.onProgress(...args),
                onSuccess: (...args) => {
                    this.onSuccess(...args);
                    resolve(this.job);
                },
                onError: (error) => {
                    this.onError(error);
                    reject(error);
                },
            });
            upload.start();
            this.job.status = 'uploading';
        });
    }
    createEndpointUrl() {
        switch (this.options.serviceName) {
            case 'byteark.stream':
                return `${this.options.serviceEndpoint}/api/upload/v1/tus/videos`;
            case 'byteark.qoder':
                return null;
            case 'tus':
            default:
                return this.options.serviceEndpoint;
        }
    }
    createUploadUrl() {
        switch (this.options.serviceName) {
            case 'byteark.qoder':
                return `${this.options.serviceEndpoint}/video-source-file/${this.job.uploadId}`;
            case 'tus':
            default:
                return null;
        }
    }
    createHeaders() {
        if (!this.options.authorizationToken && !this.options.headers) {
            return {};
        }
        if (this.options.authorizationToken) {
            return {
                ...(this.options.headers || {}),
                Authorization: `Bearer ${this.options.authorizationToken}`,
            };
        }
        return {
            ...(this.options.headers || {}),
        };
    }
    createMetadata(job) {
        if (this.options.serviceName == 'byteark.stream') {
            return {
                filename: job.file.name,
                filetype: job.file.type,
                videoKey: `${job.uploadId}`,
            };
        }
        return {
            filename: job.file.name,
            filetype: job.file.type,
        };
    }
    onProgress(bytesUploaded, bytesTotal) {
        this.job.status = 'uploading';
        this.job.progress = {
            bytesUploaded,
            bytesTotal,
            percent: makeProgressPercent(bytesUploaded, bytesTotal),
        };
        if (!this.options.onUploadProgress) {
            return;
        }
        this.triggerCallback(() => this.options.onUploadProgress(this.job, this.job.progress));
    }
    onSuccess() {
        this.job.status = 'completed';
        if (!this.options.onUploadCompleted) {
            return;
        }
        this.triggerCallback(() => this.options.onUploadCompleted(this.job));
    }
    onError(error) {
        this.job.status = 'failed';
        if (this.options.onUploadFailed) {
            return;
        }
        this.triggerCallback(() => this.options.onUploadFailed(this.job, error));
    }
    onShouldRetry(error) {
        console.error('Error when uploading', error);
        if (error instanceof Error) {
            return true;
        }
        const responseStatus = error.originalResponse ? error.originalResponse.getStatus() : 0;
        if (responseStatus === 403) {
            return false;
        }
        return true;
    }
    triggerCallback(callback) {
        try {
            callback.call(this);
        }
        catch (callbackError) {
            console.warn('[ByteArkStreamVideoUploadSDKJS] Error occurs when trigger callback', callbackError);
        }
    }
}
export function createTusUploader(job, options) {
    return new TusUploader(job, options);
}
//# sourceMappingURL=data:application/json;base64,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